import { Controller } from "@hotwired/stimulus"

// Provides visual spinner feedback on form submit buttons during Turbo submissions.
//
// Usage:
//   <form data-controller="submit-spinner">
//     <button type="submit" data-submit-spinner-target="button">Save</button>
//   </form>
//
// The button text is replaced with a spinner SVG during submission and restored after.
// Works automatically with Turbo form submissions.
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.element.addEventListener("turbo:submit-start", this.start)
    this.element.addEventListener("turbo:submit-end", this.end)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.start)
    this.element.removeEventListener("turbo:submit-end", this.end)
  }

  start = () => {
    if (!this.hasButtonTarget) return

    this.originalHTML = this.buttonTarget.innerHTML
    this.buttonTarget.disabled = true
    this.buttonTarget.innerHTML = `
      <svg class="animate-spin h-4 w-4 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    `
  }

  end = () => {
    if (!this.hasButtonTarget) return

    this.buttonTarget.disabled = false
    if (this.originalHTML) {
      this.buttonTarget.innerHTML = this.originalHTML
    }
  }
}
